import { render, staticRenderFns } from "./ProblemListIncoming.vue?vue&type=template&id=12631947&"
import script from "./ProblemListIncoming.vue?vue&type=script&lang=js&"
export * from "./ProblemListIncoming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports